export default {
  canViewSensitive: (state) => {
    return state.familyAuthorityId > 1
  }
}
